import { useCallback } from "react";
import type React from "react";

const useCardClickGuard = (
    guardedRefs: Array<React.RefObject<HTMLElement | null>>,
    onOpen: () => void
) => {
    return useCallback(
        (event: React.MouseEvent<HTMLElement>) => {
            const target = event.target as Node;
            const shouldIgnore = guardedRefs.some((ref) => ref.current?.contains(target));
            if (shouldIgnore) return;
            onOpen();
        },
        [guardedRefs, onOpen]
    );
};

export default useCardClickGuard;
